import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AppRouter, { history } from './routers/AppRouter';
import configureStore from './store/configureStore';
import { login, logout } from './actions/auth';
import { startSetWordOfDay } from './actions/wordOfDay';
import 'normalize.css/normalize.css';
import './styles/styles.scss';
import 'react-dates/lib/css/_datepicker.css';
import { firebase } from './firebase/firebase';
import LoadingPage from './components/LoadingPage';

const store = configureStore();
const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);


let hasRendered = false;
const renderApp = () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById('app'));
    hasRendered = true;
    store.dispatch(startSetWordOfDay());
  }
};

ReactDOM.render(<LoadingPage />, document.getElementById('app'));

firebase.auth().onAuthStateChanged((user) => {
  //console.log("onAuthStateChanged user = " + JSON.stringify(user, null, 2));
  if (user) {
    if (user.uid === "25NIHchSfgUW1sqeRmyE4rlWtuo2") {
      console.log("Hi, Dave!");
    }
    store.dispatch(login(user));
    renderApp();
    history.push('/admin');
  } else {
    store.dispatch(logout());
    renderApp();
    history.push('/');
  }
});



// WEBPACK FOOTER //
// ./src/app.js